import { getTermBySlot } from './api';
import { applySeo } from './seo';

export function initLegalPage(root: HTMLElement, slotKey: 'site_privacy' | 'site_service'): () => void {
  const titleEl = root.querySelector<HTMLElement>('[data-legal-title]');
  const bodyEl = root.querySelector<HTMLElement>('[data-legal-body]');
  if (!titleEl || !bodyEl) return () => {};

  let disposed = false;
  bodyEl.innerHTML = `<p class="legal-page__status">내용을 불러오는 중입니다.</p>`;

  void (async () => {
    try {
      const term = await getTermBySlot(slotKey);
      if (disposed) return;

      if (!term) {
        bodyEl.innerHTML = `<p class="legal-page__status">약관 내용을 찾을 수 없습니다.</p>`;
        return;
      }

      titleEl.textContent = term.title;
      applySeo({
        title: `${term.title} | 오병이어푸드`,
        description: `${term.title} — 주식회사 오병이어푸드`,
        robots: 'index, follow',
      });
      bodyEl.innerHTML = term.content || '<p>등록된 내용이 없습니다.</p>';
    } catch {
      if (!disposed) {
        bodyEl.innerHTML = `<p class="legal-page__status">약관 내용을 불러오지 못했습니다.</p>`;
      }
    }
  })();

  return () => {
    disposed = true;
  };
}
